
import { useState } from "react";
import {
    Container, Typography, Box, Grid, FormControl, InputLabel, TextField, CircularProgress,
    Modal,
} from "@mui/material"
import { Helmet } from "react-helmet";
import { IoIosArrowForward } from "react-icons/io";
import portada from "../../../../img/servicios/proveedores/formulario-proveedores-WEB-AXNN-02.jpg"
import "../../../../style/servicios/manejo/manejo.css";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { motion } from "framer-motion";


export const IndexProveedores = () => {
    const [formData, setFormData] = useState({
        nombre_empresa: "",
        rut_empresa: "",
        descripcion: "",
        nombre_contacto: "",
        telefono: "",
        correo: "",
    });
    const [emailError, setEmailError] = useState(false);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");



    const formatearRut = (value) => {
        // Eliminar puntos y guiones
        value = value.replace(/[.\-]/g, "");

        // Evitar que falle si está vacío
        if (value.length === 0) return "";

        let cuerpo = value.slice(0, -1);
        let dv = value.slice(-1);

        // Agregar puntos
        cuerpo = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        return `${cuerpo}-${dv}`;
    };

    const validarCorreo = (correo) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(correo);
    };

    const handleEnviar = async () => {
        // Validar campos vacíos
        if (
            !formData.nombre_empresa ||
            !formData.rut_empresa ||
            !formData.descripcion ||
            !formData.nombre_contacto ||
            !formData.telefono ||
            !formData.correo
        ) {
            setAlertMessage("Todos los campos son obligatorios");
            setErrorAlertOpen(true);
            return;
        }

        // Validar correo
        if (!validarCorreo(formData.correo)) {
            setAlertMessage("El correo ingresado no es válido");
            setErrorAlertOpen(true);
            return;
        }

        setEnviandoAlert(true);

        try {
            const res = await fetch(
                "https://www.mailaxinntus.axinntus.com/correo-proveedor.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await res.json();
            setEnviandoAlert(false);

            if (data.success) {
                setAlertMessage("Formulario enviado correctamente");
                setSuccessAlertOpen(true);

                // 🔥 Limpiar el formulario después del envío correcto
                setFormData({
                    nombre_empresa: "",
                    rut_empresa: "",
                    descripcion: "",
                    nombre_contacto: "",
                    telefono: "",
                    correo: "",
                });
            } else {
                setAlertMessage("Hubo un error al enviar el formulario");
                setErrorAlertOpen(true);
            }
        } catch (error) {
            setEnviandoAlert(false);
            setAlertMessage("Error de conexión al servidor");
            setErrorAlertOpen(true);
        }
    };


    return (
        <section>
            <Helmet>
                <title>Axinntus | ¿Quieres ser nuestro proveedor?.</title>
                <meta
                    name="description"
                    content="¿Quieres ser nuestro proveedor?"
                />
                <meta
                    name="keywords"
                    content="Axinntus, mantenimientos industriales, operación industriales, equipos multiculturalidad, equipos de excelencia, trabajar en Axinntus, personas, seguridad, activos."
                />
            </Helmet>
            <Container maxWidth="xl" sx={{
                marginTop: '-40px', '@media (max-width: 960px)': {
                    marginTop: '0px'
                },
            }} >
                <div
                    className="paginacompleta"

                >
                    <div
                        style={{ display: "flex", alignItems: "center", fontSize: "0.8rem" }}
                    >
                        {" "}
                        <p style={{ fontWeight: "400", color: "#898b8a" }}>
                            {" "}
                            Nuestros servicios
                        </p>{" "}
                        <IoIosArrowForward
                            style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                                color: "#6f7170",
                            }}
                        />{" "}
                        <strong style={{ color: "#6f7170" }}>

                            Proveedores</strong>
                    </div>
                </div>
            </Container>
            <Container maxWidth='lg' sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 4 }}>
             <Typography
  variant="h3"
  sx={{
    fontFamily: 'Compasse',
    color: '#6fa967',
    fontWeight: 600,
    textAlign:'center',
    fontSize: {
      xs: '1.4rem',   // móviles
      sm: '2.2rem',   // tablets
      md: '2.6rem',   // computadores
      lg: '3rem'      // pantallas grandes
    }
  }}
>
  ¿Quieres ser nuestro proveedor?
</Typography>


            </Container>
            <section>
                <img src={portada} alt='axinntus' title='axinntus' width='100%' />
            </section>
            <section style={{ background: "#e6e7e7", marginTop: -5 }}>
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <Container maxWidth='md' >

                        <Box display='flex' justifyContent='center' >
                            <Typography 
                            variant="h5" 
                            sx={{ 
                                fontFamily: 'Compasse', 
                                color: '#55565a', 
                                fontWeight: 600, 
                                mt: 6, 
                                mb: 7,
                                textAlign:'center',
                                 fontSize: {
                                    xs: '1.2rem',   // móviles
                                    sm: '1.8rem',   // tablets
                                    md: '2rem',   // computadores

                                    }
                                
                                }}>
                                Déjanos tu información y te contactaremos
                            </Typography>
                        </Box>

                        <Box>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={8}>
                                    <InputLabel htmlFor="nombre-empresa" sx={Label}>Nombre empresa</InputLabel>
                                    <FormControl fullWidth  >
                                        <TextField
                                            id="nombre-empresa"
                                            variant="outlined"
                                            label=""
                                            required
                                            value={formData.nombre_empresa}
                                            onChange={(e) => setFormData({ ...formData, nombre_empresa: e.target.value })}
                                            sx={input}
                                            inputProps={{
                                                style: {
                                                    fontFamily: "Compasse",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <InputLabel htmlFor="rut-empresa" sx={Label}>RUT empresa</InputLabel>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="rut-empresa"
                                            variant="outlined"
                                            label=""
                                            required
                                             value={formData.rut_empresa} 
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const rutFormateado = formatearRut(value);
                                                setFormData({ ...formData, rut_empresa: rutFormateado });
                                            }}

                                            sx={input}
                                            inputProps={{
                                                style: {
                                                    fontFamily: "Compasse",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <InputLabel htmlFor="rut-empresa" sx={Label}>Descripción de la empresa y/o servicios:</InputLabel>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="rut-empresa"
                                            variant="outlined"
                                            label=""
                                            required
                                            value={formData.descripcion}
                                            onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                                            sx={input}
                                            inputProps={{
                                                style: {
                                                    fontFamily: "Compasse",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={7}>
                                    <InputLabel htmlFor="rut-empresa" sx={Label}>Nombre contacto</InputLabel>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="rut-empresa"
                                            variant="outlined"
                                            label=""
                                            required
                                            value={formData.nombre_contacto}
                                            onChange={(e) => setFormData({ ...formData, nombre_contacto: e.target.value })}
                                            sx={input}
                                            inputProps={{
                                                style: {
                                                    fontFamily: "Compasse",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <InputLabel htmlFor="rut-empresa" sx={Label}>Teléfono</InputLabel>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="rut-empresa"
                                            variant="outlined"
                                            label=""
                                            required
                                            value={formData.telefono}
                                            onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                                            sx={input}
                                            inputProps={{
                                                style: {
                                                    fontFamily: "Compasse",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} >
                                    <InputLabel htmlFor="rut-empresa" sx={Label}>Correo electrónico</InputLabel>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="rut-empresa"
                                            variant="outlined"
                                            label=""
                                            type="mail"
                                            required
                                            value={formData.correo}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setFormData({ ...formData, correo: value });

                                                // validación simple
                                                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                                setEmailError(value !== "" && !regex.test(value));
                                            }}
                                            error={emailError}
                                            helperText={emailError ? "Correo inválido" : ""}
                                            sx={input}
                                            inputProps={{
                                                style: {
                                                    fontFamily: "Compasse",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mb: 10 }} >
                                    <button className="proveedorenviar" onClick={handleEnviar} >Envíar información</button>
                                </Grid>
                            </Grid>

                        </Box>
                    </Container>
                </motion.div>
            </section>
            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </section>
    )
}

const Label = {
    fontFamily: "Compasse",
    color: '#6f7170',
    marginLeft: '25px'

}

const input = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "50px",
        background: "#fff",

        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#bcbcbc",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#8a8a8a",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6fa967",
            borderWidth: "2px",
        },
    },

    "& .MuiInputBase-input": {
        fontFamily: "Compasse",
    },
}

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "350px",
    bgcolor: "#fff",
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
};